<div *ngIf="newsItem">
  <div class="d-flex justify-content-between">
    <ng-container *ngTemplateOutlet="newsBox; context: { item: newsItem }"></ng-container>
  </div>
</div>

<div *ngIf="news && news.length">
  <div class="row">
    <div class="col-12 col-md-6">
      <div *ngFor="let newsItem of news; let i = index;">
        @if(i % 2 === 0) {
          <ng-container *ngTemplateOutlet="newsBox; context: { item: newsItem }"></ng-container>
        }
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div *ngFor="let newsItem of news; let i = index;">
        @if(i % 2 === 1) {
          <ng-container *ngTemplateOutlet="newsBox; context: { item: newsItem }"></ng-container>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #newsBox let-item="item">
  <div class="news-item">
    @if(item.image) {
      <div class="news-image">
        <img [src]="item.image" alt="{{ item.title }}">
      </div>
    }
    <div class="news-content">
      <div class="d-flex justify-content-between">
        <div class="title" [routerLink]="getNewsLink(item.id)">{{ item.title }}</div>
        <div *ngIf="showMenu" class="action-button">
          <button class="btn btn-link text-dark" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical"></i>
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" (click)="viewNews()">View</a></li>
            <li><a class="dropdown-item" (click)="editNews()">Edit</a></li>
            <li><a class="dropdown-item" (click)="deleteNews()">Delete</a></li>
          </ul>
        </div>
      </div>
      <div class="text" [innerHTML]="item.text"></div>
      <div class="details">
        <div class="author">{{ item.author }}</div>
        <div class="date">
          {{ 'label.views_count' | translate: { count: item.views } }}
          <span class="separator">•</span>
          {{ helperService.adjustDateFormatToUTCByAddingZ(item.dateTime) | date }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
